export function caseStudyScroll(yOffset = -100) {
  const sectionsMenuToggle = document.getElementById("sections-menu-toggle");
  const sectionsMenu = document.getElementById("sections-menu");

  if (sectionsMenuToggle) {
    function toggleMenu() {
      const isOpen = sectionsMenu.classList.toggle("open-menu");
      sectionsMenuToggle.classList.toggle("active");
      if (isOpen) {
        sectionsMenu.style.maxHeight = sectionsMenu.scrollHeight + "px";
      } else {
        sectionsMenu.style.maxHeight = "0";
      }
    }

    sectionsMenuToggle.addEventListener("click", function (e) {
      toggleMenu();
      e.stopPropagation();
    });

    document.addEventListener("click", function (e) {
      if (!sectionsMenuToggle.contains(e.target)) {
        if (sectionsMenu.classList.contains("open-menu")) {
          sectionsMenu.style.maxHeight = "0";
          sectionsMenu.classList.remove("open-menu");
          sectionsMenuToggle.classList.toggle("active");
        }
      }
    });

    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        if (sectionsMenu.classList.contains("open-menu")) {
          sectionsMenu.style.maxHeight = "0";
          sectionsMenu.classList.remove("open-menu");
          sectionsMenuToggle.classList.toggle("active");
        }
      }
    });
  }
}
